export enum NextCallWhenEnum {
  TODAY       = '00000273-1000-0000-0000-000000000001',
  TOMORROW    = '00000273-1000-0000-0000-000000000002',
  TWO_DAYS    = '00000273-1000-0000-0000-000000000003',
  THREE_DAYS  = '00000273-1000-0000-0000-000000000004',
  ONE_WEEK    = '00000273-1000-0000-0000-000000000005',
  TWO_WEEKS   = '00000273-1000-0000-0000-000000000006',
  THREE_WEEKS = '00000273-1000-0000-0000-000000000007',
  SIX_WEEKS   = '00000273-1000-0000-0000-000000000008',
  ONE_MONTH   = '00000273-1000-0000-0000-000000000009'
}
